<!--error-404 start-->
<div class="error-wrapper">
    <div class="container">
        <img class="img-100" src="assets/images/other-images/sad.png" alt="">
        <div class="error-heading">
            <h2 class="headline font-danger">404</h2>
        </div>
        <div class="col-md-8 offset-md-2">
            <p class="sub-content">The page you are looking for doesn't exist or has been moved.</p>
        </div>
        <div>
            <a routerLink="/auth/sign-up" class="btn btn-danger-gradien btn-lg">BACK TO REGISTRATION</a>
        </div>
    </div>
</div>
<!--error-404 end-->
